import { Component, computed, inject, Input, OnInit, signal } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, filter, map } from 'rxjs';
import { AppState } from 'src/app/store';
import { selectPageHeaderTitle } from 'src/app/store/selectors/page.selectors';
import * as PageActions from 'src/app/store/actions/page.actions';
import { INTERCOM_ARTICLES_IDS } from '../../app.constants';
import { AccountService } from '../../services/account.service';

export interface HeaderDetails {
  title: string;
  description?: string;
  icon?: string;
  tooltip?: string;
}

@Component({
    selector: 'app-product-header',
    templateUrl: './product-header.component.html',
    styles: [
        `
      :host {
        display: block;
        position: relative;
      }
    `
    ],
    standalone: false
})
export class ProductHeaderComponent implements OnInit {

  @Input() inline = true;
  
  protected store: Store<AppState> = inject(Store);
  protected accountService: AccountService = inject(AccountService);
  public headerDetails$: Observable<HeaderDetails>;
  private intercomArticleId = signal<number | null>(null);
  public hasIntercomArticle = computed(() => Boolean(this.intercomArticleId()) && this.accountService.showIntercom());

  ngOnInit(): void {
    this.headerDetails$ = this.store.select(selectPageHeaderTitle).pipe(
      filter((translateKeyPrefix: string) => Boolean(translateKeyPrefix)),
      map((translateKeyPrefix: string) => {
        this.intercomArticleId.set(this.getIntercomArticleId(translateKeyPrefix));
        if (translateKeyPrefix.includes('titles.')) {
          return {
            title: translateKeyPrefix + '.title',
            description: translateKeyPrefix + '.description',
            icon: translateKeyPrefix + '.icon',
            tooltip: translateKeyPrefix + '.tooltip'
          };
        }
        return {
          title: translateKeyPrefix
        };
      })
    );
  }

  getIntercomArticleId(translateKeyPrefix: string): number | null {
    const title = translateKeyPrefix.split('.').pop();
    return INTERCOM_ARTICLES_IDS[title] ?? null;
  }

  showInfo(): void {
    const articleId = this.intercomArticleId();
    if (articleId) {
      this.store.dispatch(PageActions.showIntercomArticle({ articleId }));
    }
  }

}
